import { get } from "lodash"
import { createEffectiveFilterScopeSelectors, parseFilterScope } from "helpers/filter-scope"
import { getIsActive } from "modules/portfolio-root/selectors/portfolios"
import { getNormalization } from "."

export const getFilterScope = (state: unknown) => parseFilterScope(get(state, "modules.analyzeHeader.filterScope"))

const getStoredFilter = (state: unknown) => get(state, "modules.analyzeHeader.filter")

export const { getEffectiveFilterScope, getEffectiveNormalization } = createEffectiveFilterScopeSelectors({
  getFilterScope,
  getIsActive,
  getFilter: getStoredFilter,
  getNormalization,
})
